import React, { FC } from 'react'

// Constants
import { useFlag } from 'constants/flags'

// Components
import { WorkspaceSubscribePaymentDetails as WorkspaceSubscribePaymentDetailsV1 } from './WorkspaceSubscribePaymentDetails'
import {
  WorkspaceSubscribePaymentDetails as WorkspaceSubscribePaymentDetailsV2,
  WorkspaceSubscribePaymentDetailsProps,
} from './WorkspaceSubscribePaymentDetailsV2'

export const WorkspaceSubscribePaymentDetails: FC<WorkspaceSubscribePaymentDetailsProps> = props => {
  // Remove usages of 'onboarding-licenses-signup' feature flag
  // https://github.com/sketch-hq/Cloud/issues/10012
  const isOnboardingLicensesSignUpOn = useFlag('onboarding-licenses-signup')

  return isOnboardingLicensesSignUpOn ? (
    <WorkspaceSubscribePaymentDetailsV2 {...props} />
  ) : (
    <WorkspaceSubscribePaymentDetailsV1 {...props} />
  )
}
